/**
 * Wrapper runt Google Analytics Consent Mode v2.
 *
 * Default-state sätts i public/index.html till "denied" för alla
 * sample-typer. Där sätts också `client_storage: 'none'` så länge
 * användaren inte aktivt har klickat "Acceptera" tidigare – det ger
 * ett ephemeral in-memory client_id som syns i Realtime-rapporten,
 * utan att något skrivs till cookies/localStorage.
 *
 * Här uppdaterar vi consent-state när användaren gör sitt val i
 * cookie-bannern. Notera att switchen till cookie-baserat client_id
 * sker först vid nästa hård-laddning (då index.html läser
 * localStorage och kör config utan client_storage:'none'). Under
 * resten av nuvarande session behåller användaren sitt ephemeral
 * client_id även efter accept – det är OK eftersom eventen ändå
 * räknas som aktiva användare.
 *
 * Anrop:
 *   grantAnalyticsConsent()  → fullständig tracking aktiveras
 *   revokeAnalyticsConsent() → explicit denied (samma som default men
 *                              vi triggar uppdateringen så GA inte
 *                              väntar på wait_for_update-timern)
 */

function safeGtag(...args) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  window.gtag(...args);
}

export function grantAnalyticsConsent() {
  safeGtag("consent", "update", {
    ad_storage: "granted",
    analytics_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
  });
}

export function revokeAnalyticsConsent() {
  safeGtag("consent", "update", {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
  });
}
